<template>
<div class="train">
  <div class="container link">
    <div class="title-box clearfix" >
        <div class="list" style="margin-top: 22px;">
            <ul class="clearfix">
                <li class="active">友情链接</li>
            </ul>
        </div>
    </div>
    <div class="list ellipsis">
      <div class="li title" v-for="(link,index) in yq_links" :key="index"><a :href="link.url" target="_blank" ><img :src="`${global.remoteIp}/uploads/${link.picsrc}`"/></a></div>

    </div>
  </div>
</div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  props: {},
  components: {},
  data() {
    return {
      hz_links: [],
      fz_links: [],
      yq_links: [],
      global,
      selink1:"--合作单位--",
      selink2:"--行业分站--",
      selink3:"--友情链接--"
    };
  },

  mounted() {
    this.$axios
      .get("/api/links?sort=-createdAt&limit=100")
      .then((res) => {
        if (res.data) {
          for (var i = 0; i < res.data.data.length; i++) {
            if(res.data.data[i].type == "合作平台")
            {
              this.hz_links.push(res.data.data[i]);
            }else if(res.data.data[i].type == "行业分站")
            {
              this.fz_links.push(res.data.data[i]);
            }else if(res.data.data[i].type == "友情链接")
            {
              this.yq_links.push(res.data.data[i]);
            }
          }
        }
      })
  },

  methods: {
    openLink(url){
      window.open(url)
    }
  },
  watch: {
    selink1(newVal){
      window.open(newVal)
    },
    selink2(newVal){
      window.open(newVal)
    },
    selink3(newVal){
      window.open(newVal)
    }
  }
};
</script>

<style scoped>
.train{
  margin-bottom: 58px;
}
.train {
  width: 1209px;
  height: 230px;
  background: #FFFFFF;
  margin: auto;
  padding-bottom: 30px;
}
.ellipsis .title{
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.link{
	padding: 25px 0;
}
.link .list{
	display: flex;
	flex-wrap: wrap;
}
.link .li{
	width: 25%;
	font-size: 13px;
	color: #6a6a6a;
	line-height: 42px;
	/* padding-left: 20px; */
	box-sizing: border-box;
}
.link .li a{
  line-height: 30px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    margin-left: 12px;
}
</style>